export const FILES_STORE_NAME = "Files";
export const SURVEY_STORE_NAME = "SurveyInstances";
export const TICKETS_STORE_NAME = "Tickets";
export const DB_NAME = "MSM_LOOPDBv2";



// WEBPACK FOOTER //
// ./src/services/LocalDatabase/StoreNames.js